/* eslint-disable no-unused-expressions */
import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import NumberFormat from 'react-number-format';
// Change to NumericFormat in v5

const NumberFormatCustom = (props) => {
  const {
    label, name, type, className, classes, disabled, required,
    multiline, rows, control, rule, error, defaultValue,
    inputProps, id, onValidate, styleTextField, styleFromHelperText,
  } = props;

  const handleKeyDown = (e) => {
    if (e.key === '.' || e.keyCode === 190) {
      e.preventDefault();
    }
  };

  return (
    <FormControl style={className} fullWidth>
      <Controller
        name={name}
        control={control}
        rules={rule}
        defaultValue={defaultValue || ''}
        render={({ value, onChange }) => (
          <NumberFormat
            customInput={TextField}
            thousandSeparator
            label={label}
            id={id}
            size="small"
            type={type}
            fullWidth
            variant="outlined"
            multiline={multiline}
            rows={rows}
            value={value}
            style={styleTextField}
            error={!disabled && Boolean(error[name])}
            disabled={disabled}
            required={required}
            onValueChange={({ floatValue }) => {
              onChange(floatValue ?? '');
              onValidate?.(floatValue ?? '');
            }}
            inputProps={inputProps}
            FormHelperTextProps={styleFromHelperText || { style: { margin: '0 0 0 5px', color: '#d61103' } }}
            helperText={error[name]?.message || ''}
            onKeyDown={handleKeyDown}
            className={classes}
          />
        )}
      />
    </FormControl>
  );
};

export default NumberFormatCustom;
